import * as React from 'react';
import { classes } from './ColorIndicator.st.css';
import { setOpacity } from '../../../../utils/colorUtils';
import WixStylesContext from '../../../../context/wixStylesContext';
var ColorIndicator = function (_a) {
    var event = _a.event;
    var opacity = 1;
    var isGoogleColor = React.useContext(WixStylesContext).isGoogleColor;
    var backgroundColorWithoutOpacity = isGoogleColor
        ? event.extendedProps.googleColor
        : event.extendedProps.eventColor;
    return (React.createElement("div", { style: {
            position: 'relative',
        } },
        React.createElement("div", { className: classes.AllDayColorIndicatorBack }),
        React.createElement("div", { className: classes.ColorIndicator, style: {
                backgroundColor: setOpacity(opacity, backgroundColorWithoutOpacity),
                position: 'absolute',
            } })));
};
export default ColorIndicator;
//# sourceMappingURL=ColorIndicator.js.map